import React, {
  useRef,
  useState,
  useEffect,
  useMemo,
  Fragment,
  useCallback,
} from "react";
import {
  Box,
  FormControl,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Radio,
  TextField,
  MenuItem,
  Button,
  Typography,
  IconButton,
  Badge,
  InputAdornment,
  Checkbox,
  Autocomplete,
  useTheme
} from "@mui/material";
import "./Arrival.scss";
import {
  AddCircleOutline,
  Cancel,
  Edit,
  RemoveCircleOutline,
} from "@mui/icons-material";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import signatureIcon from "../../assets/icons/signature_icon.svg";
import scanningIcon from "../../assets/icons/scanning_icon.png";
import { styled } from "@mui/material/styles";
import ReactWebcam from "../../components/arrival/reactWebcam/React-webcam";
import ReactSignature from "../../components/arrival/reactSIgnature/React-signature";
import ReactOcrScanner from "../../components/arrival/ocrScanner/Ocr-Scanner";
import ArrivalFormConfig from "../../config/forms/ArrivalForm-config";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch } from "react-redux";
import { startLoader } from "../../core/store/redux/slices/Loader-slice";
import { useNavigate } from "react-router-dom";
import {
  CLEANING_STATUSES,
  ENQUIRY_SOURCES_CODE,
  ID_TYPES,
  OCCUPANCY_STATUSES,
  RESERVATION_STATUSES,
  STAY_TYPES,
  TAX_PERCENT,
} from "../../utils/Constants.js";
import { Helper } from "../../utils/Helpers.js";
import IconConstants from "../../utils/IconConstants.js";
import {
  errorToster,
  successToster,
  warnToster,
} from "../../shared/toster/Toster.jsx";
import TariffPopup from "../../components/common-components/tariff-popup/Tariff-popup.jsx";
import { format } from "date-fns-tz";
import { useMediaQuery } from "@mui/material";
import ConfirmationDlgBox from "../../components/common-components/confirmation-popup.jsx";
import { useTranslation } from "react-i18next";
import { getDataFromDB, setDataToDB } from "../../db/dbHelpers.js";
import JSZip from "jszip";
import { saveAs } from "file-saver";
const { TENTATIVE, CONFIRMED } = RESERVATION_STATUSES;
const { CLEAN, DIRTY, ASSIGNED } = CLEANING_STATUSES;
const CLEANING_STATUS_ICONS = {
  [CLEAN]: IconConstants.CleanRoomsIcon,
  [ASSIGNED]: IconConstants.CleaningPurple,
  [DIRTY]: IconConstants.UnCleanRoomsIcon,
};
const CLEANING_STATUS_LABELS = {
  [DIRTY]: "Dirty",
  [ASSIGNED]: "Assigned",
};
const WARN_ON_CLEANING_STATUSES = [DIRTY, ASSIGNED];
const {
  getLocalTimeFromUtc,
  newPrintPaymentReceipt,
  getDaysDifferenceByStayType,
  debounce,
  truncateNumberByDecimal,
  getBasePriceFromFomNetRent,
  getNetRetFromBasePrice,
  isValidDate,
  getGradientTextStyle,
  filterRatePlansForRoomType,
} = new Helper();
const defaultCountry = "India";
const defaultNationality = "indian";

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    fontSize: { xs: 12, sm: "1.44vw", md: "0.83vw" },
  },
}));

const OfflineArrival = () => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const isMob = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [defaultCountryData, setDefaultCountryData] = useState({});
  const [clearOcrData, setClearOcrData] = useState(false);
  const [clearWebcamData, setClearWebcamData] = useState(false);
  const [clearSignatureData, setClearSignatureData] = useState(false);
  const [roomTypes, setRoomTypes] = useState([]);
  const [dueAmount, setDueAmount] = useState(0);
  const [stayTypes, setStayTypes] = useState([]);
  const [proofTypes, setProofTypes] = useState([]);
  const [showOTAField, setShowOTAField] = useState(false);
  const passportIdType = proofTypes?.find(
    (v) => v.proof_type === ID_TYPES.PASSPORT
  )?.proof_type_id;
  const [bookedRooms, setBookedRooms] = useState([]);
  const [ratePlans, setRatePlans] = useState([]);
  const [offlineData, setOfflineData] = useState(null);

  useEffect(() => {
    const fetchOfflineData = async () => {
      const data = await getDataFromDB("credentials");
      setOfflineData(data);
    };
    fetchOfflineData();
  }, []);

  const { hotel_key } = offlineData?.hotel ?? {};

  const methods = useForm({
    resolver: yupResolver(
      ArrivalFormConfig(
        roomTypes,
        dueAmount,
        passportIdType,
        bookedRooms,
        [],
        showOTAField,
        t,
        stayTypes
      )
    ),
    defaultValues: {
      country_id: defaultCountryData?.country_id || "",
      nationality: "indian",
      booked_rooms: [{ checkin_date: format(new Date(), "yyyy-MM-dd HH:mm") }],
      inc_of_tax: true,
      receipt_requested: "no",
    },
  });

  const {
    control,
    handleSubmit,
    setError,
    formState: { errors },
    reset,
    getValues,
    setValue,
    watch,
    trigger,
  } = methods;

  const { fields, append, remove } = useFieldArray({
    control,
    name: "booked_rooms",
  });

  const hasEmptyFields = (obj) => {
    const fieldsToCheck = [
      "checkin_date",
      "expected_checkout_date",
      "room_type_id",
      "room_id",
      "no_of_adults",
      "stay_type_id",
      "room_rent",
    ];

    return (
      obj &&
      typeof obj === "object" &&
      fieldsToCheck.some(
        (field) =>
          obj[field] === null || obj[field] === "" || obj[field] === undefined
      )
    );
  };

  const [country, setCountry] = useState([]);
  const dispatch = useDispatch();
  const formRef = useRef();
  const { palette } = useTheme();
  const [openCamera, setOpenCamera] = useState(false);
  const [openSignature, setOpenSignature] = useState(false);
  const [openOcrScanner, setOpenOcrScanner] = useState(false);
  const [capturedImage, setCapturedImage] = useState([]);
  const [siganturedImage, setSignatureImage] = useState(null);
  const [scannedImagePng, setScannedImagePng] = useState({});
  const [availableRooms, setAvailableRooms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [roomPriceDisable, setRoomPriceDisable] = useState(true);
  const [defaultCamImage, setDefaultCamImage] = useState(null);
  const [defaultSignatureImage, setDefaultSignatureImage] = useState(null);
  const [defaultProofImage, setDefaultProofImage] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [bookingSources, setBookingSources] = useState([]);
  const [ota_list, setOtaList] = useState([]);
  const [paymentTypes, setPaymentTypes] = useState([]);
  const [reservationStatuses, setReservationStatuses] = useState([]);
  const [confirmationDlg, setConfirmationDlg] = useState(false);
  const [confirmationLabel, setConfirmationLabel] = useState("");
  const [dirtyRoomDialog, setDirtyRoomDialog] = useState({
    open: false,
    roomIndex: null,
    roomNo: null,
    statusLabel: null,
  });
  const [formData, setFormData] = useState({});
  const scrollRef = useRef(null);
  const {
    nationality,
    country_id,
    state_id,
    paid_amount,
    booked_rooms,
    inc_of_tax,
  } = watch();

  useEffect(() => {
    if (clearOcrData) {
      setClearOcrData(false);
    }
    if (clearWebcamData) {
      setClearWebcamData(false);
    }
    if (clearSignatureData) {
      setClearSignatureData(false);
    }
  }, [clearOcrData, clearWebcamData, clearSignatureData]);

  useEffect(() => {
    if (nationality === defaultNationality) {
      setValue("country_id", defaultCountryData?.country_id);
    }
  }, [defaultCountryData, nationality]);

  useEffect(() => {
    setInitialData();
  }, []);

  useEffect(() => {
    dispatch(startLoader({ loader: loading }));
  }, [loading]);

  const setStateByCountryID = async () => {
    const states = await getDataFromDB("states");
    if (states) {
      setStates(
        states.filter((state) => state.country_id === country_id) || []
      );
    }
  };

  useEffect(() => {
    country_id && setStateByCountryID();
  }, [country_id]);

  const setCitiesByStateID = async () => {
    const cities = await getDataFromDB("cities");
    if (cities) {
      setCities(cities.filter((city) => city.state_id == state_id) || []);
    }
  };

  useEffect(() => {
    state_id && setCitiesByStateID();
  }, [state_id]);

  const setInitialData = async () => {
    try {
      // Keys for storing data in IndexedDB
      const keys = [
        "countries",
        "roomTypes",
        "paymentTypes",
        "reservationStatuses",
        "bookingSources",
        "stayTypes",
        "proofTypes",
        "otaList",
        "ratePlans",
      ];

      // Check if data exists in IndexedDB
      const dbData = await Promise.all(keys.map((key) => getDataFromDB(key)));

      // If all data exists, use it
      if (dbData.every((data) => data !== undefined)) {
        setCountry(dbData[0]);
        setDefaultCountryData(() => {
          return dbData[0].find(
            (country) => country.country_name === defaultCountry
          );
        });
        setRoomTypes(dbData[1]);
        setPaymentTypes(dbData[2]);
        setReservationStatuses(dbData[3]);
        setBookingSources(dbData[4]);
        setStayTypes(dbData[5]);
        setProofTypes(dbData[6]);
        setOtaList(dbData[7]);
        setRatePlans(dbData[8]);
        return;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const bookedRoomsRoomIds = booked_rooms
    ?.map((room) => room?.room_id)
    .join(",");

  useEffect(() => {
    setBookedRooms(booked_rooms);
  }, [bookedRoomsRoomIds]);

  const bookedRoomsRoomTypeIds = booked_rooms
    ?.map((room) => room?.room_type_id)
    .join(",");
  const bookedRoomsOccupancyPrices = booked_rooms
    ?.map((room) => room?.room_rent)
    .join(",");
  const bookedRoomsCheckoutDates = booked_rooms
    ?.map((room) => room?.expected_checkout_date)
    .join(",");
  const bookedRoomsStayTypes = booked_rooms
    ?.map((room) => room?.stay_type_id)
    .join(",");
  const bookedRoomsCheckInGraceHour = booked_rooms
    ?.map((room) => room?.checkin_grace_hour)
    .join(",");

  useEffect(() => {
    setTotalOccupancyPrice();
  }, [
    bookedRoomsRoomTypeIds,
    bookedRoomsOccupancyPrices,
    bookedRoomsCheckoutDates,
    bookedRoomsStayTypes,
    inc_of_tax,
    bookedRoomsCheckInGraceHour,
  ]);

  const setTotalOccupancyPrice = () => {
    let totalPrice = 0;
    const gstRate = TAX_PERCENT / 100;

    booked_rooms?.forEach((room, index) => {
      if (
        room?.expected_checkout_date &&
        !isValidDate(room?.expected_checkout_date)
      ) {
        setError(`booked_rooms.${index}.expected_checkout_date`, {
          message: "Check-out date must be a valid date",
          type: "manual",
        });
        return;
      } else {
        setError(`booked_rooms.${index}.expected_checkout_date`, {
          message: null,
          type: "manual",
        });
      }
      const occupancyPrice = getBasePriceFromFomNetRent(
        room.room_rent,
        inc_of_tax,
        TAX_PERCENT
      );
      const taxAmount = truncateNumberByDecimal(
        Number(occupancyPrice) * gstRate
      );
      const stayTypeObj = stayTypes.find((st) => st.stay_type_id === room.stay_type_id || st.stay_type_code === room.stay_type_code);
      const stayDays =
        room?.checkin_date &&
        room?.expected_checkout_date &&
        room?.stay_type_code
          ? getDaysDifferenceByStayType(
              room.checkin_date,
              room.expected_checkout_date,
              room.stay_type_code,
              room.checkin_grace_hour,
              0,
              stayTypeObj?.standard_checkin_time,
              stayTypeObj?.standard_checkout_time
            )
          : 0;
      // TODO: RATE_PLAN_CHANGE - Offline mode requires Rate Plans to be synced and used here
      // RATE_PLAN_PRICING: Ensure rate plan prices are available offline for calculation
      const netRent = getNetRetFromBasePrice(
        occupancyPrice,
        stayDays,
        TAX_PERCENT
      );

      totalPrice += netRent;

      Object.assign(room, {
        occupancy_price: !!occupancyPrice ? Number(occupancyPrice) : 0,
        sgst: TAX_PERCENT / 2,
        cgst: TAX_PERCENT / 2,
        taxAmount,
        netRent,
        stayDays,
      });
      room?.extra_persons?.length &&
        room?.extra_persons.forEach((person) => {
          const addonPrice = getBasePriceFromFomNetRent(
            person.addon_price,
            inc_of_tax,
            TAX_PERCENT
          );
          const taxAmount = truncateNumberByDecimal(
            Number(addonPrice) * gstRate
          );
          const stayTypeObj = stayTypes.find((st) => st.stay_type_id === room.stay_type_id || st.stay_type_code === room.stay_type_code);
          const stayDays =
            person.checkin_date &&
            room.stay_type_code &&
            person.expected_checkout_date
              ? getDaysDifferenceByStayType(
                  person.checkin_date,
                  person.actual_checkout_date || person.expected_checkout_date,
                  room.stay_type_code,
                  room.checkin_grace_hour,
                  0,
                  stayTypeObj?.standard_checkin_time,
                  stayTypeObj?.standard_checkout_time
                )
              : 0;
          const netRent = getNetRetFromBasePrice(
            addonPrice,
            stayDays,
            TAX_PERCENT
          );

          totalPrice += netRent;

          Object.assign(person, {
            addon_base_price: !!addonPrice ? Number(addonPrice) : 0,
            sgst: TAX_PERCENT / 2,
            cgst: TAX_PERCENT / 2,
            taxAmount,
            netRent,
            stayDays,
          });
        });
    });
    if (totalPrice > 0) {
      setValue("total_price", totalPrice);
      const dueAmount = totalPrice;
      setDueAmount(Math.max(dueAmount, 0));
    }
  };

  const saveFormDataToFileSystem = async (formDataInstance, hotel_key) => {
    try {
      const zip = new JSZip();
      const jsonData = {};
      const fileHandles = [];

      // Separate JSON data and files
      for (const [key, value] of formDataInstance.entries()) {
        if (value instanceof File) {
          fileHandles.push({ key, file: value });
        } else {
          jsonData[key] = value;
        }
      }

      // Extract date and unique ID for folder name
      const checkinDate =
        jsonData.booked_rooms?.[0]?.checkin_date || new Date();
      const formattedDate = format(
        new Date(checkinDate),
        "yyyy-MM-dd_HH-mm-ss"
      );
      const folderName = `${JSON.parse(jsonData.data)?.name.replace(
        /\s+/g,
        ""
      )}_${formattedDate}_${hotel_key}`;

      // Add JSON metadata to ZIP
      zip.file("data.json", JSON.stringify(jsonData, null, 2));

      // Add files to ZIP
      for (const { key, file } of fileHandles) {
        zip.file(key, file);
      }

      // Generate ZIP file
      const zipBlob = await zip.generateAsync({ type: "blob" });

      // Trigger download
      saveAs(zipBlob, `${folderName}.zip`);

    } catch (error) {
      console.error("Error saving FormData as ZIP:", error);
    }
  };

  const onSubmitCheckIn = async ({
    formData,
    capturedImage,
    siganturedImage,
    scannedImagePng,
    hotel_key
  }) => {
    const {
      booked_rooms,
      tariff,
      billing_information,
      room_information,
      action,
      total_price,
      customer_image,
      proof_image,
      checkin_signature_image,
      ...rest
    } = formData;

    const booked_room = [...booked_rooms];

    booked_room.forEach((room) => {
      room.checkin_date = format(
        new Date(room.checkin_date),
        "yyyy-MM-dd HH:mm:ss"
      );
      room.expected_checkout_date = format(
        new Date(room.expected_checkout_date),
        "yyyy-MM-dd HH:mm:ss"
      );
      room.booked_on = !!room.booked_on
        ? format(new Date(room.booked_on), "yyyy-MM-dd HH:mm:ss")
        : format(new Date(), "yyyy-MM-dd HH:mm:ss");

      if (room?.extra_persons?.length) {
        room.extra_persons = room.extra_persons.map((person) => {
          return {
            ...person,
            addon_price: person.addon_base_price,
          };
        });
      }
    });

    if (!!rest?.paid_amount) {
      rest["payment_date"] = format(new Date(), "yyyy-MM-dd HH:mm:ss");
      rest["paid_through"] = "Arrival";
    }

    const FormData = require("form-data");
    const formDataInstance = new FormData();

    formDataInstance.append("data", JSON.stringify(rest));
    formDataInstance.append("booked_rooms", JSON.stringify(booked_room));

    capturedImage?.forEach((file, ind) => {
      if (typeof file !== "string")
        formDataInstance.append(`customer_image_${ind}`, file);
    });

    formDataInstance.append("checkin_signature_image", siganturedImage);

    if (
      scannedImagePng?.proof_image_front &&
      scannedImagePng?.proof_image_back
    ) {
      formDataInstance.append(
        "proof_image_front",
        scannedImagePng.proof_image_front
      );
      formDataInstance.append(
        "proof_image_back",
        scannedImagePng.proof_image_back
      );
    }

    try {
      await saveFormDataToFileSystem(formDataInstance, hotel_key);

      successToster(
        <span
          dangerouslySetInnerHTML={{
            __html: t(`pages.offline.checkin_success`, {
              name: formData?.name,
            }),
          }}
        />
      );

      // Remove the submitted room from IndexedDB
      const roomIdsToRemove = booked_room.map((room) => room.room_id);

      if (roomTypes.length > 0) {
        const updatedRoomTypes = roomTypes
          .map((roomType) => {
            return {
              ...roomType,
              rooms: roomType.rooms.filter(
                (room) => !roomIdsToRemove.includes(room.room_id)
              ),
            };
          })
          .filter((roomType) => roomType.rooms.length > 0);

        await setDataToDB("roomTypes", updatedRoomTypes);
      }
      setTimeout(() => {
        navigate("/main/offline", { replace: true });
        reset();
      }, 1500);
    } catch (error) {
      errorToster("Something went wrong!");
    } finally {
      setTimeout(() => {
        setIsSubmitted(false);
      }, 2000);
    }
  };

  const handleSaveChanges = () => {
    handleSubmit(onSubmit)();
  };

  const onSubmit = async (formData) => {
    if (!capturedImage.length) {
      warnToster(t("pages.booking_form.alert.guest_image_required"));
      setIsSubmitted(false);
      return;
    }
    if (!siganturedImage && !defaultSignatureImage) {
      warnToster(t("pages.booking_form.alert.guest_signature_required"));
      setIsSubmitted(false);
      return;
    }
    setIsSubmitted(true);
    const roomsExceedingCapacity = [];
    let exceededAdults = false;
    let exceededChildren = false;

    formData?.booked_rooms?.forEach((room, index) => {
      const roomType = roomTypes?.find(
        (type) => type?.room_type_id === room?.room_type_id
      );
      if (roomType) {
        const { max_adult, max_children } = roomType;
        const isAdultExceeded = room?.no_of_adults && room?.no_of_adults > max_adult;
        const isChildExceeded = room?.no_of_children && room?.no_of_children > max_children;
        if (isAdultExceeded || isChildExceeded) {
          roomsExceedingCapacity.push(room?.room_no);
          if (isAdultExceeded) exceededAdults = true;
          if (isChildExceeded) exceededChildren = true;
        }
      }
    });
    if (roomsExceedingCapacity.length > 0) {
      setFormData({
        formData,
        capturedImage,
        siganturedImage,
        scannedImagePng,
        hotel_key
      });

      let confirmationKey = "pages.booking_form.confirmation.check_in_with_additional_persons";
      if (exceededAdults && exceededChildren) {
        confirmationKey = "pages.booking_form.confirmation.check_in_with_additional_adults_and_children";
      } else if (exceededAdults) {
        confirmationKey = "pages.booking_form.confirmation.check_in_with_additional_adults";
      } else if (exceededChildren) {
        confirmationKey = "pages.booking_form.confirmation.check_in_with_additional_children";
      }

      setConfirmationLabel(
        <>
          {t(
            "pages.booking_form.confirmation.maximum_occupancy_reached_for_room",
            { rooms: roomsExceedingCapacity.join(", ") }
          )}
          <br />
          {t(confirmationKey)}
        </>
      );
      setConfirmationDlg(true);
      return;
    } else {
      debouncedOnSubmitCheckIn({
        formData,
        capturedImage,
        siganturedImage,
        scannedImagePng,
        hotel_key
      });
    }
  };

  const debouncedOnSubmitCheckIn = useCallback(
    debounce((data) => {
      onSubmitCheckIn(data);
    }, 1000),
    []
  );

  const handleRemove = (index) => {
    try {
      remove(index);
      const updated = availableRooms.filter((v) => v.roomIndex !== index);
      if (index !== availableRooms.length - 1) {
        const updatedWithResetIndices = updated.map((v, i) => ({
          ...v,
          roomIndex: i,
        }));
        setAvailableRooms(updatedWithResetIndices);
      } else {
        setAvailableRooms(updated);
      }
    } catch (error) {
      console.error("handleRemove Error:", error);
    }
  };

  const handleKeyEvents = (e, field) => {
    const { name, value } = e;
    const isRestrictedField =
      field === "mobile" ||
      field === "paid_amount" ||
      field === "alternate_mobile" ||
      field.includes("room_rent");

    if (isRestrictedField && (e.key === "ArrowUp" || e.key === "ArrowDown")) {
      e.preventDefault();
    }
  };

  const handleReset = () => {
    setClearOcrData(true);
    setClearWebcamData(true);
    setClearSignatureData(true);
    setSignatureImage(null);
    setCapturedImage([]);
    setScannedImagePng({});
    setDefaultCamImage(null);
    setDefaultSignatureImage(null);
    setDefaultProofImage(null);
    reset({
      nationality: "indian",
      country_id: defaultCountryData?.country_id,
      inc_of_tax: true,
    });
    setIsSubmitted(false);
    setCities([]);
  };

  const handleChange = async (e, roomIndex, selectOptions) => {
    let { name, value, type } = e.target;
    setValue(name, value);
    setError(name, null);
    if (name === "nationality") {
      setCities([]);
      setStates([]);
      setValue("city_id", "");
      setValue("state_id", "");
      setValue("passport_no", "");
      setValue("mobile", null);
      setValue("alternate_mobile", null);
      if (value.toLowerCase() === "indian") {
        setValue("country_id", defaultCountryData?.country_id);
        setValue("proof_type_id", null);
      } else {
        setValue("country_id", null);
        setValue("proof_type_id", passportIdType);
      }
    } else if (name === "enquiry_source_id") {
      const matchedOption = selectOptions?.find(
        (opt) => String(opt.value) === String(value)
      );

      const selectedLabel = matchedOption?.label;

      setValue("enquiry_source_id", matchedOption?.value ?? "");

      setShowOTAField(
        selectedLabel?.toLowerCase() === ENQUIRY_SOURCES_CODE.OTA
      );
    } else if (name === `booked_rooms.${roomIndex}.room_type_id`) {
      const roomTypeName = selectOptions?.find((v) => v.value === value)?.label;
      setValue(`booked_rooms.${roomIndex}.room_type_name`, roomTypeName);
      setValue(`booked_rooms.${roomIndex}.no_of_adults`, "");
      setValue(`booked_rooms.${roomIndex}.no_of_children`, "");
      setError(`booked_rooms.${roomIndex}.no_of_adults`, null);
      setError(`booked_rooms.${roomIndex}.no_of_children`, null);
      setValue(`booked_rooms.${roomIndex}.room_id`, null);
      const { room_base_price, rooms } =
        roomTypes?.find((v) => v.room_type_id === Number(value)) || [];
      setValue(`booked_rooms.${roomIndex}.room_rent`, Number(room_base_price));
      setValue(
        `booked_rooms.${roomIndex}.room_base_price`,
        Number(room_base_price)
      );
      setAvailableRooms((prev) => [
        ...prev.filter((entry) => entry.roomIndex !== roomIndex),
        { rooms: rooms, roomIndex },
      ]);
      setValue(`booked_rooms.${roomIndex}.rate_plan_id`, ""); // Reset Rate Plan
    } else if (name === `booked_rooms.${roomIndex}.rate_plan_id`) {
      const selectedRatePlan = ratePlans.find(
        (rp) => rp.rate_plan_id === Number(value)
      );
      const currentRoomTypeId = getValues(
        `booked_rooms.${roomIndex}.room_type_id`
      );
      const roomRate = selectedRatePlan?.room_type_rates?.find(
        (rtr) => rtr.room_type_id === currentRoomTypeId
      );
      if (roomRate) {
        setValue(`booked_rooms.${roomIndex}.room_rent`, roomRate.default_price);
      }
    } else if (name === `booked_rooms.${roomIndex}.room_id`) {
      const selectedOption = selectOptions?.find((v) => v.value === value);
      const roomNo = selectedOption?.label;
      setValue(`booked_rooms.${roomIndex}.room_no`, roomNo);
      if (WARN_ON_CLEANING_STATUSES.includes(selectedOption?.cleaning_status_code)) {
        setDirtyRoomDialog({
          open: true,
          roomIndex,
          roomNo,
          statusLabel: CLEANING_STATUS_LABELS[selectedOption.cleaning_status_code],
        });
      }
    } else if (name === `booked_rooms.${roomIndex}.no_of_adults`) {
      if (
        (value > 50) &
        !!getValues(`booked_rooms.${roomIndex}.room_type_id`)
      ) {
        setError(`booked_rooms.${roomIndex}.no_of_adults`, {
          type: "manual",
          message: "Adult count cannot exceed 50",
        });
      } else {
        setError(`booked_rooms.${roomIndex}.no_of_adults`, null);
      }
    } else if (name === `booked_rooms.${roomIndex}.no_of_children`) {
      if (
        (value > 50) &
        !!getValues(`booked_rooms.${roomIndex}.room_type_id`)
      ) {
        setError(`booked_rooms.${roomIndex}.no_of_children`, {
          type: "manual",
          message: "Child count cannot exceed 50",
        });
      } else {
        setError(`booked_rooms.${roomIndex}.no_of_children`, null);
      }
    } else if (name === "paid_amount") {
      if (!value) {
        setError("payment_type_id", null);
        setValue("payment_type_id", "");
        setValue("receipt_requested", "no");
        setValue("remarks", "");
      } else if (value > dueAmount) {
        setError("paid_amount", {
          type: "manual",
          message:
            dueAmount > 0
              ? t(
                  `pages.booking_form.alert.payment_should_be_less_than_or_equal_to`,
                  { dueAmount }
                )
              : t("pages.booking_form.alert.no_outstanding_balances"),
        });
      } else {
        setError("paid_amount", null);
      }
    } else if (name === `booked_rooms.${roomIndex}.expected_checkout_date`) {
      setValue(`booked_rooms.${roomIndex}.room_type_id`, null);
      setValue(`booked_rooms.${roomIndex}.room_id`, null);
    } else if (name === `booked_rooms.${roomIndex}.checkin_grace_hour`) {
      const checkIn = getValues(`booked_rooms.${roomIndex}.checkin_date`);
      const checkOut = getValues(
        `booked_rooms.${roomIndex}.expected_checkout_date`
      );
      const stayTypeId = getValues(`booked_rooms.${roomIndex}.stay_type_id`);
      const stayTypeCode = getValues(`booked_rooms.${roomIndex}.stay_type_code`);
      const stayTypeObj = (stayTypes || []).find((st) => Number(st.stay_type_id) === Number(stayTypeId) || st.stay_type_code === stayTypeCode);
      const code = stayTypeObj?.stay_type_code?.toLowerCase();

      if (code === "standard") {
        const maxCheckinGrace = stayTypeObj?.maximum_checkin_grace ?? 5;
        if (Number(value) > maxCheckinGrace) {
          setError(name, {
            type: "manual",
            message: t("pages.booking_form.alert.maximum_grace_hour_reached") || "Maximum grace hour reached",
          });
        } else {
          setError(name, null);
        }
      } else {
        if (checkIn) {
          const checkInDate = new Date(checkIn);
          const checkOutDate = new Date(checkOut);
          const noonTime = new Date(checkInDate);
          noonTime.setHours(12, 0, 0, 0); // Set noon time to 12:00 PM

          if ((checkInDate >= noonTime || checkOutDate <= noonTime) && value) {
            // If check-in is at or after noon, do not allow grace hours
            setError(name, {
              type: "manual",
              message: t("pages.booking_form.alert.no_grace_hours_allowed"),
            });
          } else {
            let diffHours = (noonTime - checkInDate) / (1000 * 60 * 60); // Convert to hours
            let maxGraceHours = Math.max(1, Math.ceil(diffHours)); // Ensure at least 1 hour

            if (Number(value) > maxGraceHours) {
              setError(name, {
                type: "manual",
                message: t(`pages.booking_form.alert.max_allowed_grace_hours`, {
                  maxGraceHours,
                }),
              });
            } else {
              setError(name, null);
            }
          }
        }
      }
    } else if (name === "country_id") {
      setValue("country_id", value);
      setValue("state_id", null);
      setValue("city_id", null);
    } else if (name === "state_id") {
      setValue("state_id", value);
      setValue("city_id", null);
    } else if (name === `booked_rooms.${roomIndex}.stay_type_id`) {
      const selectedStayType = selectOptions?.find(
        (v) => Number(v.value) === Number(value)
      )?.code;
      setValue(`booked_rooms.${roomIndex}.stay_type_code`, selectedStayType);
      setValue(name, value);
      setTimeout(() => {
        trigger(`booked_rooms.${roomIndex}.checkin_grace_hour`);
      }, 0);
    } else {
      setValue(name, value);
    }
  };

  let formFields = (roomIndex) => {
    const commonFields = [
      {
        label: "Nationality",
        name: "nationality",
        defaultValue: "indian",
        type: "radio",
        size: "small",
        width: { xs: "100%", sm: "55%" },
        labelStyles: {
          fontFamily: "Inter",
          fontWeight: 600,
          fontSize: { xs: "3.333vw", sm: "2.39vw", md: "1.39vw" },
          color: "#000000",
        },
        optionStyles: {
          fontWeight: 500,
          fontFamily: "Inter",
          fontSize: { xs: "3.333vw", sm: "2.39vw", md: "1.25vw" },
          color: "#3A3A3A",
        },
        disable: false,
        options: [
          { label: "Indian", value: "indian" },
          { label: "Foreigner", value: "foreigner" },
        ],
      },
      {
        label: "actions",
        name: "action",
        type: "actions",
        width: { xs: "65%", sm: "45%" },
        display: { xs: "flex", sm: "flex" },
      },
      {
        label: "Mobile Number",
        name: "mobile",
        type: "number",
        size: "small",
        labelStyles: {
          fontWeight: 500,
          fontFamily: "Inter",
          fontSize: { xs: "3.333vw", sm: "2.39vw", md: "1.25vw" },
          color: "#3A3A3A",
        },
        width: { xs: "100%", sm: "48%" },
        disable: false,
      },
      {
        label: "Alternate Mobile Number",
        name: "alternate_mobile",
        type: "number",
        size: "small",
        width: { xs: "100%", sm: "48%" },
        disable: false,
      },
      {
        label: "Mail Id",
        name: "email",
        type: "email",
        size: "small",
        width: { xs: "100%", sm: "100%" },
        disable: false,
      },
      {
        label: "ID Type",
        name: "proof_type_id",
        type: "select",
        size: "small",
        disable:
          false || nationality !== "indian" ? true : false || isSubmitted,
        width:
          nationality === "indian"
            ? { xs: "100%", sm: "100%" }
            : { xs: "100%", sm: "48%" },
        options: proofTypes
          .filter((val) =>
            nationality !== "indian"
              ? val.proof_type === "Passport"
              : val.proof_type !== "Passport"
          )
          .map((type, ind) => ({
            value: type.proof_type_id,
            label: type.proof_type,
            transLabel: t(
              `id_type_dropdown.${type.proof_type
                .toLowerCase()
                .replace(/\s+/g, "_")}`
            ),
          })),
        required: true,
      },
      {
        label: "actions",
        name: "action",
        type: "actions",
        width: { xs: 0, sm: 0 },
        display: { xs: "none", sm: "none" },
      },
      {
        label: "Passport Number",
        name: "passport_no",
        type: "text",
        size: "small",
        width: { xs: "100%", sm: "48%" },
        disable: false,
      },
      {
        label: "Name",
        name: "name",
        type: "text",
        size: "small",
        width: { xs: "100%", sm: "48%" },
        disable: false,
        maxLength: 25,
      },
      {
        label: "Country",
        name: "country_id",
        type: "autocomplete",
        size: "small",
        width: { xs: "100%", sm: "48%" },
        disable: nationality === "indian" ? true : false,
        options: country
          ?.filter((val) =>
            nationality !== "indian"
              ? val.country_name !== "India"
              : val.country_name === "India"
          )
          .map((country, ind) => ({
            value: country.country_id,
            label: country.country_name,
          })),
      },
      {
        label: "State",
        name: "state_id",
        type: "autocomplete",
        size: "small",
        width: { xs: "100%", sm: "48%" },
        options: states?.map((state, ind) => ({
          value: state.state_id,
          label: state.state_name,
        })),
        disable: false,
        noOptionsLabel: "No States Available",
        maxLength: 50,
      },
      {
        label: "City",
        name: "city_id",
        type: "autocomplete",
        size: "small",
        width: { xs: "100%", sm: "48%" },
        options: cities?.map((city, ind) => ({
          value: city.city_id,
          label: city.city_name,
        })),
        disable: false,
        noOptionsLabel: "No Cities Available",
        maxLength: 100,
      },
      {
        label: "Address",
        name: "address",
        type: "text",
        size: "large",
        width: "100%",
        disable: false,
        maxLength: 150,
      },

      {
        label: "Booking Source",
        name: "enquiry_source_id",
        type: "select",
        size: "small",
        width: { xs: "100%", sm: "48%" },
        options:
          bookingSources?.map((source) => ({
            value: String(source.enquiry_source_id), // converted to string
            label: source.source_type_name,
            transLabel: t(
              `booking_source_dropdown.${source.source_type_name
                .toLowerCase()
                .replace(/\s+/g, "_")}`
            ),
          })) || [],
        disable: false,
      },
      {
        label: "OTA",
        name: "ota_id",
        type: "select",
        size: "small",
        width: { xs: "100%", sm: "48%" },
        display: showOTAField ? "default" : "none",
        options: ota_list?.map((list) => ({
          value: list.ota_id,
          label: list.ota_name,
        })),
        disable: false,
      },
      {
        label: "Occupation",
        name: "occupation",
        type: "text",
        size: "small",
        width: { xs: "100%", sm: "48%" },
        disable: false,
        maxLength: 30,
      },
      {
        label: "Purpose of Visit",
        name: "purpose_of_visit",
        type: "text",
        size: "small",
        width: { xs: "100%", sm: showOTAField ? "48%" : "100%" },
        disable: false,
        maxLength: 30,
      },
      {
        label: "Room information",
        type: "head",
        name: "room_information",
        width: "50%",
      },
      {
        label: "Inclusive Of Tax",
        type: "checkbox",
        name: "inc_of_tax",
        width: "40%",
        disable: false,
      },
    ];
    const roomFields = [
      {
        label: "Check in Date and Time",
        name: `booked_rooms.${roomIndex}.checkin_date`,
        size: "small",
        type: "datetime-local",
        width: { xs: "100%", sm: "48%" },
        disable: true,
        defaultValue: format(new Date(), "yyyy-MM-dd HH:mm"),
        minDate: format(new Date(), "yyyy-MM-dd HH:mm"),
      },
      {
        label: "Check Out Date and Time",
        name: `booked_rooms.${roomIndex}.expected_checkout_date`,
        type: "datetime-local",
        size: "small",
        disable:
          !getValues(`booked_rooms.${roomIndex}.checkin_date`) ||
          false ||
          !!getValues(`booked_rooms.${roomIndex}.occupancy_id`),
        width: { xs: "100%", sm: "48%" },
        minDate: format(
          getValues(`booked_rooms.${roomIndex}.checkin_date`) || new Date(),
          "yyyy-MM-dd HH:mm"
        ),
      },
      {
        label: "Select Room Type",
        name: `booked_rooms.${roomIndex}.room_type_id`,
        type: "select",
        size: "small",
        width: { xs: "100%", sm: "48%" },
        disable: false,
        options: roomTypes?.map((type, ind) => ({
          value: type.room_type_id,
          label: type.room_type_name,
          rooms: type.rooms,
        })),
        noOptionsLabel: "No Room Types Available",
      },
      {
        label: "Rate Plan",
        name: `booked_rooms.${roomIndex}.rate_plan_id`,
        type: "select",
        size: "small",
        width: { xs: "100%", sm: "48%" },
        disable: !getValues(`booked_rooms.${roomIndex}.room_type_id`),
        options: filterRatePlansForRoomType(
          ratePlans,
          getValues(`booked_rooms.${roomIndex}.room_type_id`),
          getValues(`booked_rooms.${roomIndex}.rate_plan_id`)
        ).map((val) => ({
          value: val.rate_plan_id,
          label: t(val.rate_plan_name),
        })),
        noOptionsLabel: "Select Room Type First",
      },
      {
        label: "Room Number",
        name: `booked_rooms.${roomIndex}.room_id`,
        type: "select",
        size: "small",
        width: { xs: "100%", sm: "48%" },
        disable: false || !!getValues(`booked_rooms.${roomIndex}.occupancy_id`),
        options: availableRooms
          .find((v) => v?.roomIndex === roomIndex)
          ?.rooms?.map((room, ind) => ({
            value: room.room_id,
            label: room.room_no,
            cleaning_status_code: room.cleaning_status_code,
          })),
        noOptionsLabel: "No Rooms Available",
      },
      {
        label: "Number of Adults",
        name: `booked_rooms.${roomIndex}.no_of_adults`,
        type: "number",
        size: "small",
        width: { xs: "100%", sm: "48%" },
        disable: false,
      },
      {
        label: "Number of Children",
        name: `booked_rooms.${roomIndex}.no_of_children`,
        type: "number",
        size: "small",
        width: { xs: "100%", sm: "48%" },
        disable: false,
      },
      {
        label: "Stay Type",
        name: `booked_rooms.${roomIndex}.stay_type_id`,
        type: "select",
        size: "small",
        width: { xs: "100%", sm: "48%" },
        disable: false,
        options: stayTypes?.map((type, ind) => ({
          value: type.stay_type_id,
          label: type.stay_type_name,
          code: type.stay_type_code,
          transLabel: t(
            `stay_type_dropdown.${type.stay_type_name.toLowerCase()}`
          ),
        })),
        noOptionsLabel: "No Stay Types Available",
      },
      {
        label: "Room Rent",
        name: `booked_rooms.${roomIndex}.room_rent`,
        type: "number",
        size: "small",
        width: { xs: "100%", sm: "48%" },
        disable: roomPriceDisable === roomIndex ? false : true,
        inputAdornment: (
          <InputAdornment position="end">
            <IconButton
              size="small"
              onClick={(e) =>
                setRoomPriceDisable(
                  roomPriceDisable === roomIndex ? null : roomIndex
                )
              }
            >
              {roomPriceDisable === roomIndex ? (
                <Cancel fontSize="small" />
              ) : (
                <Edit fontSize="small" />
              )}
            </IconButton>
          </InputAdornment>
        ),
      },
      {
        label: "Check In Grace Time",
        name: `booked_rooms.${roomIndex}.checkin_grace_hour`,
        type: "number",
        size: "small",
        disable:
          watch(`booked_rooms.${roomIndex}.occupancy_status_code`) ===
          OCCUPANCY_STATUSES.ROOM_SHIFT,
        width: { xs: "100%" },
        max: 12,
        value: 0,
        show: [STAY_TYPES.NOON, STAY_TYPES.STANDARD].includes(
          watch(`booked_rooms.${roomIndex}.stay_type_code`)
        ),
      },
    ];
    const billingFields = isMob
      ? [
          {
            label: "Billing Information",
            name: "billing_information",
            type: "head",
            width: "100%",
          },
          {
            label: "Total Amount",
            name: "total_price",
            type: "number",
            size: "small",
            width: { xs: "100%", sm: "48%" },
            disable: true,
          },
          {
            label: "Tariff",
            name: "tariff",
            type: "tariff",
            width: { xs: "100%", sm: "100%" },
            disable: false,
            labelStyles: {
              textAlign: "left",
            },
          },
          {
            label: "Total Advance Paid",
            name: "total_paid_amount",
            type: "number",
            size: "small",
            width: { xs: "100%", sm: "48%" },
            disable: true,
          },

          {
            label: "Enter Payment",
            name: "paid_amount",
            type: "number",
            size: "small",
            width: { xs: "100%", sm: "48%" },
            disable: false,
          },
          {
            label: !!paid_amount ? "Payment Mode" : "Payment Mode Optional",
            name: "payment_type_id",
            type: "select",
            size: "small",
            width: { xs: "100%", sm: "48%" },
            disable: false || !paid_amount,
            options: paymentTypes.map((type, ind) => ({
              value: type.payment_type_id,
              label: type.payment_type,
              transLabel: t(
                `payment_mode_dropdown.${type.payment_type
                  .toLowerCase()
                  .replace(/\s+/g, "_")}`
              ),
            })),
          },
          {
            label: "Remarks",
            name: "remarks",
            type: "text",
            size: "small",
            width: { xs: "100%", sm: "48%" },
            disable: false || !paid_amount,
            maxLength: 50,
          },
          {
            label: "Receipt",
            name: "receipt_requested",
            defaultValue: "no",
            type: "radio",
            size: "small",
            width: { xs: "100%", sm: "48%" },
            labelStyles: {
              fontWeight: 500,
              width: { xs: "35%", sm: "25%" },
              fontSize: { xs: "3.333vw", sm: "2.39vw", md: "1.12vw" },
              textAlign: { xs: "right", sm: "center" },
              color: "#565656",
            },
            optionStyles: {
              width: { xs: "20%", sm: "30%" },
              fontSize: { xs: "3.333vw", sm: "2.39vw", md: "1.12vw" },
              color: "#A7A7A7",
            },
            disable: false || !paid_amount,
            options: [
              { label: "Yes", value: "yes" },
              { label: "No", value: "no" },
            ],
          },
        ]
      : [
          {
            label: "Billing Information",
            name: "billing_information",
            type: "head",
            width: "100%",
          },
          {
            label: "Total Amount",
            name: "total_price",
            type: "number",
            size: "small",
            width: { xs: "100%", sm: "48%" },
            disable: true,
          },

          {
            label: "Total Advance Paid",
            name: "total_paid_amount",
            type: "number",
            size: "small",
            width: { xs: "100%", sm: "48%" },
            disable: true,
          },
          {
            label: "Tariff",
            name: "tariff",
            type: "tariff",
            width: { xs: "100%", sm: "100%" },
            disable: false,
            labelStyles: {
              textAlign: "left",
            },
          },
          {
            label: "Enter Payment",
            name: "paid_amount",
            type: "number",
            size: "small",
            width: { xs: "100%", sm: "48%" },
            disable: false,
          },
          {
            label: !!paid_amount ? "Payment Mode" : "Payment Mode Optional",
            name: "payment_type_id",
            type: "select",
            size: "small",
            width: { xs: "100%", sm: "48%" },
            disable: false || !paid_amount,
            options: paymentTypes.map((type, ind) => ({
              value: type.payment_type_id,
              label: type.payment_type,
              transLabel: t(
                `payment_mode_dropdown.${type.payment_type
                  .toLowerCase()
                  .replace(/\s+/g, "_")}`
              ),
            })),
          },
          {
            label: "Remarks",
            name: "remarks",
            type: "text",
            size: "small",
            width: { xs: "100%", sm: "48%" },
            disable: false || !paid_amount,
            maxLength: 50,
          },
        ];
    return { commonFields, roomFields, billingFields };
  };

  const handleProceedDirtyRoom = () => {
    setDirtyRoomDialog({ open: false, roomIndex: null, roomNo: null, statusLabel: null });
  };

  const handleGoWithAnotherRoom = () => {
    const { roomIndex } = dirtyRoomDialog;
    if (roomIndex !== null && roomIndex !== undefined) {
      setValue(`booked_rooms.${roomIndex}.room_id`, null);
      setValue(`booked_rooms.${roomIndex}.room_no`, null);
      setError(`booked_rooms.${roomIndex}.room_id`, null);
    }
    setDirtyRoomDialog({ open: false, roomIndex: null, roomNo: null, statusLabel: null });
  };

  const renderField = (formField, field, error, roomIndex) => {
    const commonProps = {
      ...field,
      name: formField.name,
      size: formField.size,
      display: formField.display,
      type: formField.type,
      label: t(
        `pages.booking_form.${formField.label
          .toLowerCase()
          .replace(/\s+/g, "_")}`
      ),
      autoComplete: "off",
      error: !!error?.message,
      helperText: !!error?.message
        ? ["paid_amount"].includes(formField.name) ||
          formField.name.includes("checkin_grace_hour")
          ? error?.message
          : t(
              `pages.booking_form.alert.${error?.message
                ?.toLowerCase()
                ?.replace(/\s+/g, "_")}`
            )
        : "",
      disabled: formField?.disable,
      InputProps: {
        endAdornment: formField?.inputAdornment,
        sx: { fontSize: { xs: "3.333vw", sm: "1.92vw", md: "1.12vw" } },
      },
      InputLabelProps: {
        shrink:
          formField.type === "datetime-local"
            ? isMobile && !getValues(formField.name)
              ? false
              : true
            : undefined,
        sx: {
          fontWeight: 400,
          fontFamily: "Inter",
          fontSize: { xs: "3.333vw", sm: "1.92vw", md: "1.12vw" },
        },
      },
      FormHelperTextProps: {
        sx: { fontSize: { xs: "3.08vw", sm: "1.44vw", md: "0.83vw" } },
      },
    };

    const handleInput = (e) => {
      const { value } = e.target;
      e.target.value =
        formField.type === "number" &&
        ![
          "address",
          "passport_no",
          "mobile",
          "alternate_mobile",
          "paid_amount",
          "total_price",
        ].includes(formField.name) &&
        !formField.name.includes("room_rent")
          ? value.replace(/[^0-9]/g, "")
          : ["paid_amount"].includes(formField.name) ||
            formField.name.includes("room_rent")
          ? Number(value) === 0
            ? null
            : value.replace(/[^0-9]/g, "")
          : formField.type === "text" &&
            !["address", "passport_no", "remarks"].includes(formField.name)
          ? value.replace(/[0-9]/g, "").replace(/^\s+/, "")
          : ["passport_no"].includes(formField.name)
          ? value.replace(/[^A-Za-z0-9\s]/g, "").replace(/^\s+/, "")
          : ["mobile", "alternate_mobile"].includes(formField.name)
          ? Number(value) === 0 && nationality === defaultNationality
            ? null
            : value
                .replace(/[^0-9]/g, "")
                .slice(0, nationality === "indian" ? 10 : 15)
          : ["email"].includes(formField.name)
          ? value.toLowerCase()
          : value.replace(/^\s+/, "");
    };

    switch (formField?.type) {
      case "text":
      case "email":
      case "number":
        return (
          <TextField
            {...commonProps}
            value={watch(formField.name) || ""}
            onWheel={(e) => e.target.blur()}
            onKeyDown={(e) => handleKeyEvents(e, formField?.name)}
            onKeyUp={(e) => handleKeyEvents(e, formField?.name)}
            onInput={handleInput}
            onChange={(e) => handleChange(e, roomIndex)}
            inputProps={{
              max: formField?.max,
              min: 0,
              maxLength: formField.maxLength || "",
            }}
            className={
              formField.name.includes("no_of_children") ||
              formField.name.includes("no_of_adults")
                ? ""
                : "NoSpinnerTextField no-spinner"
            }
          />
        );
      case "select":
        return (
          <TextField
            {...commonProps}
            select
            value={watch(formField.name) || ""}
            sx={formField?.style}
            onChange={(e) => handleChange(e, roomIndex, formField?.options)}
          >
            {formField?.options?.length > 0 ? (
              formField?.options?.map((option) => (
                <MenuItem
                  key={option.value}
                  value={parseInt(option.value)}
                  disabled={
                    formField.name === `booked_rooms.${roomIndex}.room_id` &&
                    [TENTATIVE, CONFIRMED].includes(
                      reservationStatuses.find(
                        (status) =>
                          status.reservation_status_code === option.status
                      )?.reservation_status_code
                    )
                  }
                  sx={{
                    backgroundColor:
                      formField.name === `booked_rooms.${roomIndex}.room_id`
                        ? [TENTATIVE, CONFIRMED].includes(
                            reservationStatuses.find(
                              (status) =>
                                status.reservation_status_code === option.status
                            )?.reservation_status_code
                          )
                          ? "#9747FF"
                          : "#D9FFD8"
                        : "",
                    fontSize: { xs: "3.333vw", sm: "1.8vw", md: "1vw" },
                  }}
                >
                  {formField.name === `booked_rooms.${roomIndex}.room_id` &&
                  CLEANING_STATUS_ICONS[option.cleaning_status_code] ? (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        columnGap: { xs: "6px", sm: "6px", md: "0.4vw" },
                      }}
                    >
                      <Box
                        component="img"
                        src={CLEANING_STATUS_ICONS[option.cleaning_status_code]}
                        alt={option.cleaning_status_code}
                        sx={{
                          width: { xs: "16px", sm: "16px", md: "1.1vw" },
                          height: { xs: "16px", sm: "16px", md: "1.1vw" },
                        }}
                      />
                      <span>{option.label}</span>
                    </Box>
                  ) : [
                    "ID Type",
                    "Booking Source",
                    "Stay Type",
                    "Payment Mode",
                  ].includes(formField.label) ? (
                    option.transLabel
                  ) : (
                    option.label
                  )}
                </MenuItem>
              ))
            ) : (
              <MenuItem
                value=""
                disabled
                sx={{ fontSize: { xs: "3.333vw", sm: "1.8vw", md: "1vw" } }}
              >
                {t(
                  `pages.booking_form.${formField.noOptionsLabel
                    ?.toLowerCase()
                    ?.replace(/\s+/g, "_")}`
                )}
              </MenuItem>
            )}
          </TextField>
        );
      case "autocomplete":
        return (
          <Autocomplete
            {...field}
            noOptionsText={t(
              `pages.booking_form.${formField.noOptionsLabel
                ?.toLowerCase()
                ?.replace(/\s+/g, "_")}`
            )}
            value={
              typeof watch(formField.name) == "string"
                ? watch(formField.name)
                : formField?.options?.find(
                    (v) => v?.value === watch(formField?.name)
                  ) || ""
            }
            disablePortal
            disableClearable={!['state_id', 'city_id'].includes(formField?.name)}
            disabled={formField?.disable}
            onChange={(e, newval) => {
              handleChange(
                { target: { name: formField.name, value: newval?.value ?? null } },
                roomIndex,
                formField?.options
              );
            }}
            options={formField?.options || []}
            sx={{
              "& .MuiInputBase-input": {
                fontSize: { xs: "3.333vw", sm: "1.92vw", md: "1.111vw" },
              },
              ".MuiAutocomplete-noOptions": {
                fontSize: { xs: "3.333vw", sm: "1.8vw", md: "0.5vw" },
              },
            }}
            ListboxProps={{
              sx: {
                fontSize: { xs: "3.333vw", sm: "1.8vw", md: "1vw" },
                ".MuiAutocomplete-noOptions": {
                  fontSize: { xs: "3.333vw", sm: "1.8vw", md: "0.5vw" },
                },
              },
            }}
            filterOptions={(options, state) => {
              const inputValue = state.inputValue
                .replace(/\s+/g, "")
                .toLowerCase();

              const capitalizedInputValue =
                state?.inputValue.trim()?.charAt(0)?.toUpperCase() +
                state?.inputValue.trim()?.slice(1)?.toLowerCase();
              const filtered = options?.filter((option) =>
                option.label
                  .replace(/\s+/g, "")
                  .toLowerCase()
                  .includes(inputValue)
              );
              if (
                formField?.name != "country_id" &&
                formField?.name != "state_id" &&
                formField?.name != "city_id" &&
                inputValue &&
                inputValue.length > 2 &&
                !filtered.some(
                  (opt) =>
                    opt.label.replace(/\s+/g, "").toLowerCase() === inputValue
                )
              ) {
                return [
                  ...filtered,
                  {
                    label: `Click here to add "${capitalizedInputValue}"`,
                    value: capitalizedInputValue,
                    addNew: true,
                  },
                ];
              }
              return filtered;
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                name={formField.name}
                size={formField.size}
                label={t(`pages.booking_form.${formField.label.toLowerCase()}`)}
                error={!!error?.message}
                helperText={
                  !!error?.message
                    ? t(
                        `pages.booking_form.alert.${error?.message
                          ?.toLowerCase()
                          ?.replace(/\s+/g, "_")}`
                      )
                    : ""
                }
                onInput={(e) => {
                  let { value } = e.target;
                  value = value.replace(/[^a-zA-Z\s]/g, "");
                  e.target.value = value;
                }}
                InputProps={{
                  ...params.InputProps,
                  inputProps: {
                    ...params.inputProps,
                    maxLength: formField?.maxLength,
                  },
                }}
                InputLabelProps={{
                  sx: {
                    fontSize: { xs: "3.333vw", sm: "1.92vw", md: "1.111vw" },
                  },
                }}
                FormHelperTextProps={{
                  sx: {
                    fontSize: { xs: "3.08vw", sm: "1.44vw", md: "0.83vw" },
                  },
                }}
              />
            )}
          />
        );
      case "datetime-local":
        return (
          <TextField
            {...commonProps}
            value={watch(formField?.name) || ""}
            onChange={(e) => handleChange(e, roomIndex)}
            inputProps={{ min: formField.minDate, max: formField.maxDate }}
          />
        );
      case "head":
        return (
          <Box
            sx={{ width: "100%", scrollMarginTop: { md: "6vw" } }}
            ref={formField.name === "room_information" ? scrollRef : null}
          >
            <Typography
              sx={{
                fontSize: { xs: "3.333vw", sm: "2.4vw", md: "1.39vw" },
                fontWeight: 600,
                ...getGradientTextStyle(palette)
              }}
            >
              {t(
                `pages.booking_form.${formField.label
                  .toLowerCase()
                  .replace(/\s+/g, "_")}`
              )}
            </Typography>
          </Box>
        );
      case "radio":
        return (
          <RadioGroup
            {...field}
            name={formField.name}
            row
            defaultValue={formField?.defaultValue}
            onChange={(e) => handleChange(e)}
            sx={{
              display: "flex",
              columnGap: "0.1vw",
              alignItems: "center",
            }}
          >
            <FormLabel sx={{ ...formField?.labelStyles, marginRight: "3%" }}>
              {t(
                `pages.booking_form.${formField.label
                  .toLowerCase()
                  .replace(/\s+/g, "_")}`
              )}
            </FormLabel>
            {formField?.options.map((option, ind) => (
              <FormControlLabel
                key={ind}
                disabled={formField?.disable}
                value={option.value}
                sx={{
                  fontFamily: "Inter",
                  "& .MuiFormControlLabel-label": {
                    fontWeight: 500,
                    color: "#3A3A3A",
                    fontSize: { xs: "3.333vw", sm: "1.918vw", md: "1.23vw" },
                  },
                }}
                defaultChecked={
                  option.value === "indian" || option.value === "no"
                }
                control={
                  <Radio
                    size="small"
                    sx={{ "&.Mui-checked": { color: "#DFA828" } }}
                  />
                }
                label={t(`pages.booking_form.${option.label.toLowerCase()}`)}
              />
            ))}
          </RadioGroup>
        );
      case "actions":
        return (
          <Box
            sx={{
              width: formField?.width,
              display: formField?.display,
              marginLeft: "auto",
              position: "relative",
              left: { xs: "5%", sm: "auto" },
            }}
          >
            <Box
              sx={{
                width: { xs: 1 },
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <IconButton
                aria-label="CameraAlt IconButton"
                sx={{ padding: 0 }}
                onClick={() => setOpenCamera(true)}
                disabled={false}
              >
                <StyledBadge
                  showZero
                  badgeContent={
                    capturedImage
                      ? capturedImage?.length
                      : 0 || defaultCamImage?.length
                      ? 1
                      : 0
                  }
                >
                  <Box
                    sx={{
                      height: { xs: "5.38vw", sm: "2.512vw", md: "1.456vw" },
                      width: { xs: "7.18vw", sm: "3.36vw", md: "1.944vw" },
                    }}
                  >
                    <img
                      src={IconConstants.Camera}
                      alt=""
                      style={{ height: "100%", width: "100%" }}
                    />
                  </Box>
                </StyledBadge>
              </IconButton>
              <IconButton
                onClick={() => setOpenSignature(true)}
                aria-label="Signature IconButton"
                sx={{ padding: 0 }}
                disabled={false}
              >
                <Box
                  sx={{
                    height: { xs: "6.15vw", sm: "2.87vw", md: "1.66vw" },
                    width: { xs: "6.28vw", sm: "2.94vw", md: "1.7vw" },
                  }}
                >
                  <img
                    src={signatureIcon}
                    alt=""
                    style={{ height: "100%", width: "100%" }}
                  />
                </Box>
              </IconButton>
              <IconButton
                onClick={() => setOpenOcrScanner(true)}
                aria-label="CameraAlt IconButton"
                sx={{ padding: 0 }}
                disabled={false}
              >
                <StyledBadge
                  showZero
                  badgeContent={
                    !!scannedImagePng
                      ? Object.values(scannedImagePng).filter(
                          (value) =>
                            value !== null &&
                            value !== "" &&
                            value !== undefined
                        )?.length
                      : 0
                  }
                >
                  <Box
                    sx={{
                      height: { xs: "5.7vw", sm: "2.798vw", md: "1.625vw" },
                      width: { sm: "3.45vw", xs: "6.4vw", md: "2vw" },
                    }}
                  >
                    <img
                      src={scanningIcon}
                      alt="Arrival down"
                      style={{ height: "100%", width: "100%" }}
                    />
                  </Box>
                </StyledBadge>
              </IconButton>
            </Box>
          </Box>
        );
      case "tariff":
        return (
          <Box
            sx={{
              width: formField.width,
              position: isMobile ? "relative" : "absolute",
              textAlign: { xs: "right", sm: "right" },
            }}
          >
            <Box
              sx={{
                position: "relative",
                width: isMob ? "100%" : "50%",
                top: { xs: "1.495vw", sm: 0 },
              }}
            >
              <Button
                disabled={formField?.disable}
                sx={{
                  fontSize: { xs: "3.59vw", sm: "1.44vw", md: "0.83vw" },
                  fontWeight: 500,
                  color: "#547AFF",
                  textTransform: "none",
                  textDecoration: "underline",
                  padding: "0px",
                }}
                onClick={(e) => setAnchorEl(e.currentTarget)}
              >
                {!!anchorEl
                  ? t(`pages.booking_form.hide`)
                  : t(`pages.booking_form.${formField.label.toLowerCase()}`)}
              </Button>
            </Box>
          </Box>
        );
      case "checkbox":
        return (
          <FormControlLabel
            {...field}
            sx={{
              marginLeft: "auto",
              "& .MuiFormControlLabel-label": {
                fontSize: { xs: "2.821vw", sm: "1.92vw", md: "1.11vw" },
              },
            }}
            value={inc_of_tax}
            name={formField.name}
            disabled={formField.disable}
            control={<Checkbox checked={inc_of_tax || false} size="small" />}
            label={t(
              `pages.booking_form.${formField.label
                .toLowerCase()
                .replace(/\s+/g, "_")}`
            )}
            labelPlacement="end"
          />
        );
      default:
        return null;
    }
  };

  const memoizedForm = useMemo(() => {
    return (
      <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
        <Box className="arrival-form-fields">
          {(nationality !== "indian"
            ? formFields().commonFields
            : formFields().commonFields?.filter(
                (commonField) => commonField.name !== "passport_no"
              )
          )?.map((commonField, index) => (
            <FormControl
              key={index}
              sx={{
                width: commonField?.width,
                marginTop: "4.5%",
                display: commonField.display,
              }}
            >
              <Controller
                {...methods}
                name={commonField.name}
                defaultValue=""
                render={({ field, fieldState: { error } }) => {
                  return renderField(commonField, field, error);
                }}
              />
            </FormControl>
          ))}

          {fields.map((_, countInd) => (
            <Fragment key={countInd}>
              {formFields(countInd)
                .roomFields?.filter(
                  (field) => field.show === undefined || field.show
                )
                .map((roomfield, index) => {
                  return (
                    <FormControl
                      key={index}
                      sx={{ width: roomfield?.width, marginTop: "4.5%" }}
                    >
                      <Controller
                        {...methods}
                        name={roomfield.name}
                        defaultValue=""
                        render={({ field, fieldState: { error } }) => {
                          return renderField(roomfield, field, error, countInd);
                        }}
                      />

                      {roomfield.name ===
                        `booked_rooms.${countInd}.expected_checkout_date` && (
                        <Box
                          sx={{
                            position: "absolute",
                            right:
                              countInd === fields.length - 1 &&
                              fields.length > 1 &&
                              fields.length < 10 &&
                              !getValues(
                                `booked_rooms.${countInd}.occupancy_id`
                              )
                                ? isMob
                                  ? "-13%"
                                  : "-26%"
                                : "-13%",
                            display: "flex",
                            flexDirection: {
                              xs: "column",
                              sm: "row",
                            },
                            alignItems: "center",
                          }}
                        >
                          {countInd === fields.length - 1 &&
                            fields.length < 10 && (
                              <IconButton
                                onClick={() => {
                                  append();
                                  setValue(
                                    `booked_rooms.${fields.length}.checkin_date`,
                                    getValues(`booked_rooms.${0}.checkin_date`)
                                  );
                                }}
                                disabled={hasEmptyFields(
                                  !!booked_rooms
                                    ? booked_rooms[fields.length - 1]
                                    : {}
                                )}
                                size="medium"
                              >
                                <AddCircleOutline
                                  fontSize="medium"
                                  sx={{
                                    color: hasEmptyFields(
                                      !!booked_rooms
                                        ? booked_rooms[fields.length - 1]
                                        : {}
                                    )
                                      ? "gray"
                                      : "#E2A81F",
                                  }}
                                />
                              </IconButton>
                            )}
                          {fields.length > 1 &&
                            !getValues(
                              `booked_rooms.${countInd}.occupancy_id`
                            ) && (
                              <IconButton
                                onClick={() => handleRemove(countInd)}
                                size="medium"
                              >
                                <RemoveCircleOutline
                                  fontSize="medium"
                                  sx={{ color: "#FF5A3E" }}
                                />
                              </IconButton>
                            )}
                        </Box>
                      )}
                      {roomfield.name ===
                        `booked_rooms.${countInd}.checkin_date` && (
                        <Box
                          sx={{
                            position: "absolute",
                            left: { xs: "-10%", sm: "-13%" },
                            top: "10%",
                            borderRadius: "50%",
                            backgroundColor: "#F9F1DD",
                            height: {
                              xs: "5.128vw",
                              sm: "2.88vw",
                              md: "2.22vw",
                            },
                            width: {
                              xs: "5.128vw",
                              sm: "2.88vw",
                              md: "2.22vw",
                            },
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: {
                                xs: "3.333vw",
                                sm: "1.44vw",
                                md: "1.12vw",
                                fontWeight: 700,
                                color: "#000000",
                              },
                            }}
                          >
                            {countInd + 1}
                          </Typography>
                        </Box>
                      )}
                    </FormControl>
                  );
                })}
            </Fragment>
          ))}

          {formFields()
            .billingFields.filter((v) =>
              [
                "total_price",
                "total_paid_amount",
                "billing_information",
                "tariff",
              ].includes(v.name)
            )
            .map((billingField, index) => (
              <FormControl
                key={index}
                sx={{
                  width: billingField?.width,
                  marginTop: {
                    sm:
                      billingField.name !== "tariff" &&
                      billingField.name !== "payment_type_id" &&
                      billingField.name !== "paid_amount" &&
                      "4.5%",
                    md: billingField.name !== "tariff" && "4.5%",
                    xs: billingField.name !== "tariff" && "4.5%",
                  },
                  marginBottom: {
                    sm: billingField.name == "tariff" && "-4%",
                  },
                }}
              >
                <Controller
                  {...methods}
                  name={billingField.name}
                  defaultValue=""
                  render={({ field, fieldState: { error } }) => {
                    return renderField(billingField, field, error);
                  }}
                />
              </FormControl>
            ))}
        </Box>
      </form>
    );
  }, [formRef, handleSubmit, onSubmit, t]);

  return (
    <>
      <Box
        className="arrival-form-outerbox"
        sx={{
          width: { xs: "80.5%", sm: "80.5%", md: "62%" },
        }}
      >
        <Box className="arrival-form-nationality">
          <Typography
            sx={{
              fontSize: { xs: "4.1vw", sm: "2.39vw", md: "1.38vw" },
              fontWeight: 700,
              ...getGradientTextStyle(palette),
            }}
          >
            {/* Customer Information */}
            {t("pages.booking_form.customer_information")}
          </Typography>
        </Box>

        {memoizedForm}

        <Box
          className="arrival-form-buttons"
          sx={{
            flexDirection: { xs: "column-reverse", sm: "row" },
            rowGap: "3vw",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              width: {
                xs: 1,
                sm: "65%",
              },
              display: "flex",
              alignItems: "center",
              flexDirection: { xs: "column-reverse", sm: "row" },
              justifyContent: "space-between",
              gap: { xs: "3vw", sm: "1.8vw" },
            }}
          >
            <Button
              onClick={handleReset}
              disabled={isSubmitted}
              sx={{
                fontWeight: 600,
                width: { xs: 1, sm: "68%" },
                fontSize: { xs: "4.1vw", sm: "1.92vw", md: "1.12vw" },
              }}
              variant="outlined"
            >
              {t("pages.booking_form.clear")}
            </Button>
            <Button
              onClick={handleSaveChanges}
              disabled={isSubmitted}
              sx={{
                fontWeight: 600,
                width: { xs: 1, sm: "68%" },
                fontSize: { xs: "4.1vw", sm: "1.92vw", md: "1.25vw" },
              }}
              variant="contained"
            >
              {t("pages.booking_form.check_in")}
            </Button>
          </Box>
        </Box>
      </Box>
      <Box>
        <ReactWebcam
          openWebcam={openCamera}
          getCapturedImage={(data) => {
            setCapturedImage(data);
            //setCamImageLength(!!data ? [data] : []);
            setDefaultCamImage(null);
          }}
          closeWebcam={() => {
            setOpenCamera(!openCamera);
          }}
          defaultCamImage={defaultCamImage}
          clearWebcamData={clearWebcamData}
          imageName={"customer-image"}
        />
        <ReactSignature
          openSignature={openSignature}
          getSignature={(data) => {
            setSignatureImage(data);
            setDefaultSignatureImage(null);
          }}
          clearSign={() => setDefaultSignatureImage(null)}
          closeSignature={setOpenSignature}
          defaultSignatureImage={defaultSignatureImage}
          clearSignatureData={clearSignatureData}
        />
        <ReactOcrScanner
          openOcrScanner={openOcrScanner}
          closeOcrScanner={() => {
            setOpenOcrScanner(!openOcrScanner);
            setScannedImagePng({});
            setDefaultProofImage(null);
          }}
          getScannedImagePng={(data) => {
            setOpenOcrScanner(!openOcrScanner);
            setScannedImagePng(data);
            setDefaultProofImage(null);
          }}
          getOcrData={(data) => {
            // populateOcrData(data);
          }}
          defaultProofImage={defaultProofImage}
          handleOpen={() => {
            setOpenOcrScanner(!openOcrScanner);
          }}
          setLoading={setLoading}
          clearOcrData={clearOcrData}
        />
      </Box>
      <TariffPopup
        tariffData={booked_rooms}
        isQuickReservation={false}
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
      />
      <ConfirmationDlgBox
        open={confirmationDlg}
        confirmFunction={() => {
          setConfirmationDlg(false);
          if (formData) {
            debouncedOnSubmitCheckIn(formData);
          }
        }}
        setOpen={setConfirmationDlg}
        label={confirmationLabel}
        setIsSubmitted={setIsSubmitted}
      />
      <ConfirmationDlgBox
        open={dirtyRoomDialog.open}
        label={`Room ${dirtyRoomDialog.roomNo} is ${dirtyRoomDialog.statusLabel}. Do you want to proceed?`}
        confirmFunction={handleProceedDirtyRoom}
        cancelFunction={handleGoWithAnotherRoom}
        setOpen={(open) =>
          setDirtyRoomDialog((prev) => ({ ...prev, open }))
        }
        confirmLabel="Proceed"
        cancelLabel="Go with Another Room"
      />
    </>
  );
};

export default OfflineArrival;
